/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import SignaturePad from 'signature_pad';
import utils from '@/utils/utils';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    defaultEvent: {
      type: Boolean,
      default: true
    }
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      currValue: this.value,
      signaturePad: ''
    };
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      if (val) {
        this.init();
      }
      this.$emit('input', val);
      this.$refs['signature-pad'].focus();
    }
  },
  methods: {
    resizeCanvas: function resizeCanvas(canvas) {
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    },
    clear: function clear() {
      this.signaturePad.clear();
    },
    drawSign: function drawSign(data) {
      this.signaturePad.fromDataURL(data);
    },
    submit: function submit() {
      var _this = this;
      var isEmpty = this.signaturePad.isEmpty();
      if (!isEmpty) {
        var data = this.signaturePad.toDataURL('image/svg+xml');
        utils.rotateBase64Img(data, -90, /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.$emit('on-success', res);
                    _this.currValue = false;
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.$vux.toast.text(i18n.tc("529"));
      }
    },
    init: function init() {
      var _this2 = this;
      var canvas = this.$refs['signature-pad'];
      // if (this.signaturePad) return
      this.signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        throttle: 30,
        minDistance: 10
      });
      this.$nextTick(function () {
        setTimeout(function () {
          _this2.resizeCanvas(canvas);
        }, 100);
      });
    }
  },
  mounted: function mounted() {
    this.init();
  }
};